module.exports = __webpack_public_path__ + "./images/6bb8b85ecb028d71dbb89f0a23fd6b9d.webp";